export const getCanonicalPath = (pathName, params) => {
  if (pathName === "/") {
    return `https://${process.env.SHOP_URL}`;
  } else {
    const isProduct = pathName.match(/^.*(?=(\/(?:quick-view|product)))/);

    if (isProduct && params?.handle) {
      return `https://${process.env.SHOP_URL}/products/${params.handle}`;
    } else {
      return `https://${process.env.SHOP_URL}${pathName}`;
    }
  }
};
